import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  Button
} from '../../components';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import css from './HelpPage.module.css';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));



const HelpPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const accordeonClasses = useStyles();

  // prettier-ignore
  return (
    <StaticPage
      title="Help page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HelpPage',
        description: 'Centre d’aide',
        name: 'Help page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Comment pouvons-nous vous aider ?</h1>
          <div className={css.underTitle}>
            <p className={css.slimText}>Si vous ne trouvez pas la réponse à votre question, n’hésitez-pas à nous contacter par mail ou par téléphone 7j / 7</p>
            <p>📲<a href="tel:0756829146">07-56-82-91-46</a></p>
            <p>📩<a>contact@ollo.best</a></p>
            </div> 



          <div className={css.contentWrapper}>


          <p className={css.title11}>
          Je souhaite me garer avec ollo 🚗 
          </p>
            {/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */}

            <Grid container xs={12}>


              
            <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                          
          <p className={css.title2}>
          Comment fonctionnent les locations ollo ?
          </p></Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                            
          <p className={css.text}>
          Ollo est le premier service de location de parking entre particuliers, sans rencontre entre automobilistes et propriétaires. Plusieurs moyens d’accès au parking sont proposés sur ollo :          </p>

          <p className={css.text}>
          -	Récupération du badge dans une boîte à clé à proximité de l’entrée
          </p>

          <p className={css.text}>
          -	Ouverture du portail avec votre smartphone
          </p>

          <p className={css.text}>
          -	Récupération du badge dans un commerce à proximité du parking
          </p>

          <p className={css.text}>
          Vous pouvez stationner quelques heures, quelques jours ou quelques semaines. Pour les locations de plusieurs mois ou annuelles, 
          <strong> vous pouvez contacter directement notre service : contact@ollo.best</strong>
          </p>

                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                     

                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                           <p className={css.title2}>
                           Y a t-il une durée minimale de location ?
          </p></Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                               <p className={css.text}>
                               Non, avec ollo vous pouvez stationner <strong>quelques heures, quelques jours ou semaines ! </strong> Pour les 
                               <strong> demandes supérieures à 1 mois </strong>ou pour de la <strong>location mensuelle</strong>, il vous faudra 
                               <strong> contacter le service client </strong> directement en écrivant à <strong>contact@ollo.best.</strong>
                               </p>

                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>






                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                           <p className={css.title2}>
              Quel type de place est proposé sur ollo?
          </p></Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                               <p className={css.text}>
          Les places disponibles sur ollo sont des places <strong>mises à disposition par des particuliers</strong> qui louent leur(s) place(s) sur ollo. Elles se situent donc toutes dans des <strong>parkings résidentiels sécurisés.</strong>              </p>


                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>



                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
               <p className={css.title2}>
               Comment se déroule la remise des accès?
          </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                               <p className={css.text}>
          Ollo propose <strong>un système d’arrivées autonomes</strong> sans rencontre physique entre vous et le propriétaire.               </p>
        
          <p className={css.text}>
          Selon le parking, plusieurs solutions :
          </p>

          <p className={css.text}>
          <strong>1) Une boîte à clé à proximité de l’entrée</strong>
          </p>

          <p className={css.text}>
          Sur certains parkings, une boîte à clé est installée à côté de l’entrée. Le code d’ouverture de celle-ci vous sera communiquée dès lors que vous aurez effectué votre réservation.
          </p>

          <p className={css.text}>
          <strong>2) Ouverture du parking avec votre téléphone mobile</strong>
          </p>

          <p className={css.text}>
          Sur certains de nos parkings, il vous suffit d’appeler un numéro de téléphone pour déclencher automatiquement l’ouverture du parking.          </p>


          <p className={css.text}>
          <strong>3) Récupérer le badge dans un point-relais situé à moins de 5 minutes du parking</strong>
          </p>

          <p className={css.text}>
          Les accès de certains de parkings sont à récupérer dans un point relais partenaire à proximité du parking. L’adresse du point relais est indiquée dans la description du parking et pour les récupérer, il vous faudra vous munir du code qui vous sera envoyé après votre réservation.          </p>




                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>



                     
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                          
          <p className={css.title2}>
          Comment se déroule une réservation?
          </p></Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                            
          <p className={css.text}>
          Dès lors que vous avez trouvé le parking qu’il vous faut, vous pouvez le réserver instantanément. Une fois votre réservation effectuée, rendez-vous dans <strong> “Mes Réservations”</strong>  (en haut à droite) > <strong> “Mes réservations”</strong> .               </p>

          <p className={css.text}>
          <strong> En cliquant sur votre réservation,</strong> vous trouverez un <strong>document PDF à télécharger</strong> qui vous explique comment accéder au parking, récupérer les accès, votre numéro de place etc.              </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>








                         
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                          
                           <p className={css.title2}>
          Comment sont déterminés les prix?
          </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                  
          <p className={css.text}>
          Le prix de base indiqué sur les annonces est un prix par jour et correspond à <strong>24h de location</strong>. Comme il est parfois difficile de savoir avec <strong>précision son horaire d’arrivée, sur ollo, vous précisez seulement vos créneaux d’arrivée et de départ : matin</strong> (7h à 12h), <strong>après-midi</strong> (12h à 18h) ou <strong>soir</strong> (18h à 00h).               </p>

          <p className={css.text}>
          Comme il est parfois difficile de savoir avec précision l’heure à laquelle on arrive, sur ollo, 
          vous <strong>précisez seulement vos créneaux d’arrivée et de départ : matin </strong>(7h à 12h), <strong>après-midi</strong> (12h à 18h) ou 
          <strong>soir</strong> (18h à 00h).
          </p>

                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>


                
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                          
                           <p className={css.title2}>
          Je ne sais pas exactement à quelle heure j’arrive et je pars, c’est grave?
          </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                             
                              <p className={css.text}>
                              Absolument pas, lors de votre réservation, vous devez juste préciser si vous arrivez / partez le matin, l’après-midi ou le soir.
                              </p>
                              
                              <p className={css.dummyHiddenText}>asdddddddddddddddd ddddddddddddddd dddddddddddddddd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd</p>
                               </div> 
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
              
          <p className={css.title2}>
          Je souhaite annuler ma réservation, c’est possible?
          </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
              
          <p className={css.text}>
          Tout à fait, vous pouvez annuler votre réservation et vous faire rembourser jusqu’à 24h avant le début de celle-ci. Si votre réservation est dans moins de 24h et que vous souhaitez l’annuler : cela n’est pas prévu dans les conditions générales. N’hésitez pas cependant à nous contacter pour voir ce que nous pouvons faire. Le remboursement total sera dans ce cas visible sur votre compte bancaire dans un délai de 5 à 7 jours.
                         </p>


                         <p className={css.text}>
                         Si votre réservation a lieu dans moins de 24h et que vous souhaitez l’annuler : cela n’est pas prévu dans les conditions générales. N’hésitez pas cependant à nous contacter pour voir ce que nous pouvons faire. 
                         </p>


                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
             Quand suis-je débité ?
          </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
              
                               <p className={css.text}>
          Pour les réservations instantanées, vous êtes débités dès lors que vous avez finalisé votre réservation. Pour les réservations nécessitant une validation du propriétaire de la place, vous êtes débité une fois que celui-ci a accepté votre demande de réservation.
             </p>

                                <p className={css.text}>
                                Pour les réservations nécessitant une validation du propriétaire, vous êtes débité une fois que celui-ci a accepté votre demande de réservation.
                                </p>

                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>


                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
             Que se passe-t-il si je ne trouve pas l'entrée / sortie ou si j’ai une question concernant le parking 🤔?
          </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
              
          <p className={css.text}>
          Chez ollo, nous connaissons nos parkings partenaires ! Vous pouvez donc nous appeler à n’importe quelle heure du jour et de la nuit, un de nos agents se fera un plaisir de vous accompagner et vous communiquer toutes les informations dont vous aurez besoin.
         </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
         Que se passe-t-il si je ne quitte pas ma place de parking à temps?
          </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
              
                                  <p className={css.text}>
                                  En cas de retard, vos accès au parking peuvent être désactivés, c’est pour cela qu’il vous faudra impérativement contacter notre service client : <strong>contact@ollo.best</strong>
                                  </p>

                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>


                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
            Puis-je entrer et sortir plusieurs fois de mon parking ollo pendant la durée de location ?
             </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
          <p className={css.text}>
          Tout à fait ! Du début à la fin de votre réservation, vous pouvez entrer et sortir librement et autant de fois que vous le souhaitez. Vous gardez avec vous le moyen d’accès au parking tout au long de votre réservation.            
           </p>




                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                     

                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
           Puis-je prolonger ma location lorsqu’elle se termine ?
           </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
            
                               <p className={css.text}>
                               Oui, sous réserve de la disponibilité du parking. Pour ce faire, il vous faudra effectuer une nouvelle réservation.          </p>

                               <p className={css.dummyHiddenText}>asdddddddddddddddd ddddddddddddddd dddddddddddddddd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd</p>


                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                     <br/><br/>

                  <p className={css.title11}>
                  Je souhaite louer ma place sur ollo 🤝
                  </p>
            
                  <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          
                           <p className={css.title2}>
          Je suis intéressé pour louer ma place sur ollo, quelles sont les étapes ?
                       </p>
</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
            
          <p className={css.text}>
          La première étape pour louer votre (vos) place(s) de parking sur ollo est de remplir le formulaire <span className={css.orangeText}>+ Proposer ma place</span>. A la suite de cela, vous serez contacté par le city manager de votre ville pour organiser une visite de votre parking (afin de déterminer la solution de remise des accès, s’assurer que le parking correspond aux critères ollo, prendre des photos…). A la suite de cette visite, votre parking est prêt pour la mise en location !         
            </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

          
                  <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                           <p className={css.title2}>
            Comment se déroule la remise des accès avec mes locataires ?
            </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
           



          <p className={css.text}>
          Chez ollo, nous favorisons <strong>les locations avec arrivées autonomes</strong>, si vous choisissez cette option, il vous faudra, lors de la visite, choisir <strong>le moyen d’accès de votre choix proposé et offert</strong> par ollo :            </p>

            <p className={css.text}>
            1) Boîte à clés (dispositif de stockage à clés) installée à proximité du parking 
                        </p>
            <ul>
              <li className={css.text}>✅ Un code temporaire pour chaque utilisateur différent pour chaque location.</li>
              <li className={css.text}>✅ Notification d’ouverture et de fermeture pour faciliter les check-in / check-out</li>
            </ul>


            <p className={css.text}>
            2) Point relais / Consigne à clés
             </p>
             <p className={css.text}>
             Notre partenariat avec une célèbre consigne à clés va vous permettre d’utiliser les casiers connectés installés dans des commerces partenaires, où l’utilisateur pourra récupérer les accès en échange d’un code qui lui sera communiqué avant le début de sa location. 
             </p>
            <ul>
              <li className={css.text}>✅ Code temporaire pour chaque utilisateur</li>
              <li className={css.text}>✅ Notification d’ouverture et de fermeture pour faciliter les check-in / check-out</li>
            </ul>

            <p className={css.text}>
            3) Remise en main propre
             </p>

             <p className={css.text}>
             Dans ce cas, il faudra programmer un check-in et un check-out directement avec le locataire.
             </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

    
                     
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                           <p className={css.title2}>
             Comment se déroule une location ?
            </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
           

                               <p className={css.text}>
          Vous recevez un mail pour vous informer de chaque réservation pour votre place. L’avantage avec ollo, c’est que <strong>vous n’avez aucune action à réaliser</strong>, ollo se charge de répondre aux interrogations des utilisateurs, de la remise des accès et du paiement sécurisé. L’utilisation du service permet d’éviter l’étape de la signature d’un bail de location. A la suite de chaque réservation, vous recevez la totalité du chiffre d'affaires réalisé, moins la <strong>commission ollo de 15%</strong>.        
              </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                           <p className={css.title2}>
              Quand suis-je crédité du montant de la location ?
            </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  
                                 
           
          <p className={css.text}>
          Vous recevez le montant de la réservation sur votre compte bancaire dans un délai de 1 à 3 jours à la fin de chaque réservation.
            </p>
            <p className={css.dummyHiddenText}>asdddddddddddddddd ddddddddddddddd dddddddddddddddd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd</p>




                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>


                     
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          


                           <p className={css.title2}>
            Je souhaite mettre en pause ou stopper la location de ma place avec ollo, comment faire?
            </p>

</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  


                               <p className={css.text}>
          Depuis votre espace personnel, vous pouvez, à votre guise, mettre en pause (ou supprimer) votre annonce, et la réactiver quand vous le souhaitez.
            </p>

            <p className={css.dummyHiddenText}>asdddddddddddddddd ddddddddddddddd dddddddddddddddd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd ddddddd ddddddddd dddddddd dddddddddd ddddd dd</p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>






                     



                        









                     
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                           <p className={css.title2}>
            Est-il légal de sous-louer ma place de parking ?       
                 </p>


</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  

                               
                               <p className={css.text}>
          Dans le cas où vous êtes propriétaire de la place, aucun problème ! Si vous êtes locataire, d’après l’article 1717 du Code Civil, <strong>vous devez avoir l’accord de votre propriétaire.</strong> Vous pouvez ensuite sous-louer votre place de parking en toute légalité.
             </p>




                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>


                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                       
             <p className={css.title2}>
             Comment intervient Allianz dans les locations ollo ?
                              </p>



</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  

                           

          <p className={css.text}>
          Notre partenaire Allianz intervient en complément de l'assurance véhicule du client et de l'assurance de la copropriété et peut vous proposer une assurance de protection juridique.
                       </p>




                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>

                     



  
                     
                           
                     <Grid container item xs={12}>
                     <Accordion>
                         <AccordionSummary
                           expandIcon={<ExpandMoreIcon />}
                           aria-controls="panel1a-content"
                           id="panel1a-header"
                           className={css.roundButton}
                         >
                           <Typography className={accordeonClasses.heading}>
                    
          

                           <p className={css.title2}>
                       Que faire en cas de problème dans le parking ?
                              </p>



</Typography>
                         </AccordionSummary>
                         <AccordionDetails>
                               <div className={css.accordeonContent}>  

                           

                               <p className={css.text}>
                               Nous vous invitons à envoyer un mail avec toutes les informations, photos, justificatifs à <strong>contact@ollo.best</strong> Notre service client vous assistera dans les plus brefs délais pour vous indiquer le processus à suivre afin de résoudre au mieux votre problème.                                 </p>



                               </div>
                         
                         </AccordionDetails>
           </Accordion>
                     </Grid>

                     <div className={css.separator}></div>



                 
             </Grid>




{/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */}


                    
        </div>



        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HelpPage;
